import { NotesListWebComponent } from './component/NotesListWebComponent';
import { WEB_COMPONENT_NOTES_LIST } from '../../webcomponents.constants';

export { NotesListWebComponent };

window.customElements.define(WEB_COMPONENT_NOTES_LIST, NotesListWebComponent);
